import { Table, TableProps } from "@mui/material";
import { LoadingBox } from "../LoadingBox";
type SelectionTableProps = {
  loading?: boolean;
} & TableProps;
export const SelectionTable = ({ loading, sx, ...others }: SelectionTableProps) => {
  return (
    <LoadingBox loading={loading}>
      <Table
        sx={[
          {
            borderCollapse: "collapse",
            width: "100%",
            "& td, & th": {
              borderBottom: "none",
              "&:last-child": {
                textAlign: "right",
                paddingRight: "1.25rem",
              },
              "&:first-of-type": {
                textAlign: "left",
                paddingLeft: "1.25rem",
              },
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...others}
      ></Table>
    </LoadingBox>
  );
};

export default SelectionTable;
